export function userLogin(data, formWrapper) {
    if(!formWrapper){
        return
    }

    let request = new XMLHttpRequest(),
        method = 'POST',
        url = ajax_object.ajax_url,
        btn = formWrapper.querySelector('button'),
        error_container = formWrapper.querySelector('.error_message');

    btn.classList.remove('btn-arrow')
    btn.classList.add('btn-loader')
    btn.innerText = '';
    error_container.innerText = ''

    request.open(method, url, true);
    request.send(data)

    request.onerror = function (){
        console.log('ERROR: ' + this.response)
    }

    request.onload = function(){
        console.log(this.responseText);


        try {
            let res = JSON.parse(this.response)

            if(res.success === true) {
                window.location.href = res.data.redirect_to;
                return;
            }

            btn.classList.remove('btn-loader')
            btn.classList.add('btn-arrow')
            btn.innerText = 'Login'
            error_container.innerText += `${res.data.error}`;

        } catch(error) {
            console.log(this.response)

        }
    }
}

export function userLogout(){
    let btns = document.querySelectorAll('.btn-logout a');

    if(!btns){
        return;
    }

    btns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            let request = new XMLHttpRequest(),
                method = 'POST',
                url = ajax_object.ajax_url,
                data = new FormData();

            data.append('action', 'log_user_out');
            data.append('_wpnonce', ajax_object.wp_nonce)

            request.open(method, url, true);
            request.send(data)

            request.onerror = function (){
                console.log('ERROR: ' + this.response)
            }

            request.onload = function (){
                try {
                    let res = JSON.parse(this.response)

                    if(res.success === true){
                        location.reload();
                    }

                    console.log('ERROR : ' + this.response);

                } catch (error){
                    console.log(this.response)
                }

            }

        })
    })
}